<div [ngClass]="visible ? 'isDialog' : 'isNotDialog'">
  <div id="mainDiv" class="main-div" [ngClass]="visible ? 'main-div-dialog' : 'main-div'">
    <p-dropdown id="selecionarPerfil" [options]="atividadesList" [(ngModel)]="selectedAtividade" optionLabel="label"
      [placeholder]="'atividade-economica-add.placeholders.selecione' | translate" [filter]="true" filterBy="label" [showClear]="true"
      appendTo="body" panelStyleClass="dropdown-panel-above-modal"
      styleClass="w-full">
    </p-dropdown>
    <button *ngIf="!isDialog" pButton icon="pi pi-search" class="btn-primary" (click)="showDialog()">
    </button>
    <button pButton [label]="'Adicionar' | translate" icon="pi pi-check" (click)="addAtividade()" class="btn-primary"
      style="white-space: nowrap;">
    </button>
  </div>
  <p-table [value]="atividadesTable" [tableStyle]="{ 'min-width': '100%' }">
    <ng-template pTemplate="header">
      <tr>
        <th>{{'Nome' | translate}}</th>
        <th>{{'codigo' | translate}}</th>
        <th>{{'Data_de_Inclusao' | translate}}</th>
        <th style="width: 80px;">{{'Acoes' | translate}}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-atividade>
      <tr>
        <td>{{ atividade.nome }}</td>
        <td>{{ atividade.codigo }}</td>
        <td>{{ atividade.criadoEm | date: 'dd/MM/yyyy' }}</td>
        <td>
          <i (click)="deleteAtividade(atividade.id)" [pTooltip]="'atividade-economica-add.tooltips.excluir' | translate"
            class="pi pi-trash icon"></i>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">{{'nenhum_registro_encontrado' | translate}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
